var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3639 30.2571C37.499 23.9809 36.574 14.7303 30.2979 9.59521C24.0218 4.4601 14.7712 5.38506 9.63608 11.6612C4.50097 17.9373 5.42593 27.1879 11.702 32.323C17.9782 37.4581 27.2288 36.5332 32.3639 30.2571Z",
    fill: "#E51C27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7981 15.1391C16.8797 14.5317 17.9566 14.0396 18.3391 14.3546L22.872 18.0804L27.402 21.8091C27.7845 22.124 27.6551 23.1335 26.6512 23.3922L21.7275 24.9698L16.2329 27.0309C16.1271 27.0704 16.0128 27.0814 15.9014 27.0628C15.79 27.0441 15.6855 26.9965 15.5984 26.9247C15.5112 26.8529 15.4444 26.7595 15.4048 26.6538C15.3651 26.548 15.354 26.4337 15.3724 26.3223L16.3341 20.5353L16.7981 15.1391Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7363 15.2287C16.7548 15.1169 16.8024 15.012 16.8744 14.9246C16.9463 14.8371 17.0401 14.7702 17.1462 14.7306C17.2523 14.6909 17.367 14.68 17.4787 14.6988C17.5904 14.7176 17.6951 14.7656 17.7823 14.8378L22.4699 18.4343L26.9915 22.1602C27.2193 22.6073 27.1181 23.2175 26.6513 23.3918L21.1595 25.453L15.6677 27.5142C15.5618 27.5543 15.4471 27.5658 15.3353 27.5475C15.2235 27.5291 15.1185 27.4816 15.031 27.4098C14.9434 27.3379 14.8763 27.2442 14.8366 27.1381C14.7968 27.032 14.7857 26.9173 14.8045 26.8056L15.7661 21.0185L16.7363 15.2287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.bad77a125db42c9a76c3649027ae98d1.svg";
export { ForwardRef as ReactComponent };